import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/avatar-b.png'


const _hoisted_1 = { class: "user-avatar-view" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  src: _imports_0,
  alt: "默认头像"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAvatar',
  props: ['src', 'alt'],
  setup(__props) {

// eslint-disable-next-line no-undef
const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.src)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: props.src,
          alt: props.src
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("img", _hoisted_3))
  ]))
}
}

})